import React from 'react';
import { motion } from 'framer-motion';

const deepDive = [
  'Tenant Isolation Strategy',
  'Service Boundary Design',
  'Queue Orchestration',
  'Caching and Read Models',
];

const ArchitectureDeepDiveV3 = () => {
  return (
    <section className="w-full rounded-2xl bg-white border border-gray-200">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 mb-6">Architecture Deep Dive</h2>
        <p className="text-lg text-gray-600 mb-8">Key patterns used to scale real-world Laravel platforms.</p>
        <div className="grid md:grid-cols-2 gap-5">
          {deepDive.map((item, i) => (
            <motion.div
              key={item}
              initial={{ opacity: 0, x: -12 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: i * 0.07 }}
              viewport={{ once: true }}
              className="rounded-xl bg-gray-50 p-6 shadow-md hover:shadow-lg hover:-translate-y-2 transition-all duration-300"
            >
              <h3 className="text-xl font-semibold text-gray-900">{item}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArchitectureDeepDiveV3;
